import Config from "@/utils/config"
import {
	login
} from "@/api/auth/login"
import {
	adList
} from "@/api/website"
import {
	noticesList
} from "@/api/cms/notice"
import {
	floors,
	floatLayer,
	apiDefaultSearchWords
} from "@/api/pc"
import {
	mapGetters
} from "vuex"
import {
	couponList,
	receiveCoupon
} from "@/api/coupon"
import {
	goodsPageSeckill,
	timeList
} from "@/api/seckill"
import {
	goodsSkuPage,
	goodsReco
} from "@/api/goods/goods"
import CountDown from "vue2-countdown"

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import { diyviewInfo } from '@/api/pc';

import { goodsPage } from '@/api/groupbuy';

import { getToken } from "@/utils/auth"

import { addCollect } from "@/api/goods/goods_collect"
import { deleteGoods } from "@/api/member/collection"


export default {
	inject: ["reload"],
	name: "index",
	components: {
		CountDown,
		Swiper,
        SwiperSlide
	},
	data: () => {
		return {
			is_overlay: false,
			swiperOption: {
				pagination: {
				  	el: '.swiper-pagination'
				},
				slidesPerView: 5,
  				// slidesPerGroup: 2,
				spaceBetween: 20,
				loop: true,
				// freeMode: true,
				navigation: {
					nextEl: '.ddp-content-arrow-right',
    				prevEl: '.ddp-content-arrow-left',
				},
			},
			swiperOption1: {
				pagination: {
					el: '.swiper-pagination'
				},
				slidesPerView: 5,
					// slidesPerGroup: 2,
				spaceBetween: 20,
				loop: true,
				// freeMode: true,
				navigation: {
					nextEl: '.ddp-content-arrow-right1',
					prevEl: '.ddp-content-arrow-left1',
			  	},
			},
			swiperOption2: {
				pagination: {
					el: '.swiper-pagination'
				},
				slidesPerView: 5,
					// slidesPerGroup: 2,
				spaceBetween: 20,
				loop: true,
				// freeMode: true,
				navigation: {
					nextEl: '.ddp-content-arrow-right2',
					prevEl: '.ddp-content-arrow-left2',
			  	},
			},
			ImageAds: [],
			ImageAdsLoading: true,
			adimgList: [],
			adimgListLoading: true,
			adimgList1: [],
			adimgList1Loading: true,
			ddpsList: [],
			ddpsListLoading: true,
			tdingList: [],
			tdingListLoading: true,
			hdsList: [],
			hdsListLoading: true,
			tdrNowList: [],
			tdrNowListLoading: true,
			loadingAd: true,
			loadingFloor: true,
			adList: [],
			adLeftList: [],
			adRightList: [],
			noticeList: [],
			couponList: [],
			floorList: [],
			floatLayer: {
				is_show: false,
				link: {
					url: ""
				}
			},
			indexFloatLayerNum: 0,
			shopApplyUrl: Config.baseUrl + "/shop/login/register",
			shopCenterUrl: Config.baseUrl + "/shop/index/index",
			storeUrl: Config.baseUrl + "/store",
			isSub: false,
			siteId: 0,
			listData: [],
			seckillTimeMachine: {
				currentTime: 0,
				startTime: 0,
				endTime: 0
			},
			seckillText: "距离结束",
			backgroundColor: "", // 顶部banner背景颜色
			// 悬浮搜索
			searchType: "goods",
			searchTypeText: "商品",
			keyword: "",
			defaultSearchWords: "",
			isShow: false,
			goodsList:[],

			ddpsTimeList: {"code":0,"message":"操作成功","data":{"page_count":1,"count":6,"list":[{"id":38,"site_id":3,"seckill_name":"秒杀","status":1,"remark":"","start_time":1643091457,"end_time":1645715857,"goods_id":814,"seckill_time_id":",2,","seckill_price":"19.90","goods_name":"Solid Color Show Waist Sleeveless Dress","goods_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122032423164283626300678.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122032423164283626300785.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122032422164283626299553.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122032422164283626296121.jpg","goods_stock":1599,"price":"28.00","sale_num":0,"recommend_way":0},{"id":39,"site_id":3,"seckill_name":"秒杀","status":1,"remark":"","start_time":1643091532,"end_time":1645715932,"goods_id":816,"seckill_time_id":",,2,,","seckill_price":"0.01","goods_name":"Lace cutout v-neck polka dot jacquard shirt","goods_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122033058164283665864019.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122033058164283665852643.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122033058164283665860076.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122033058164283665871841.jpg","goods_stock":2000,"price":"0.10","sale_num":0,"recommend_way":0},{"id":36,"site_id":3,"seckill_name":"秒杀","status":1,"remark":"","start_time":1643091417,"end_time":1645715817,"goods_id":819,"seckill_time_id":",2,","seckill_price":"19.90","goods_name":"Contrast Panel Short Sleeve Pocket Long T-Shirt","goods_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122033835164283711576132.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122033835164283711568890.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122033835164283711574667.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122033835164283711570971.jpg","goods_stock":2000,"price":"31.00","sale_num":0,"recommend_way":0},{"id":34,"site_id":3,"seckill_name":"秒杀","status":1,"remark":"","start_time":1643091375,"end_time":1645715775,"goods_id":822,"seckill_time_id":",2,","seckill_price":"19.90","goods_name":"Solid Color V-Neck Long Sleeve Casual Chiffon Jacket","goods_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122035410164283805058876.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122035410164283805067362.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122035410164283805062688.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122035410164283805061520.jpg","goods_stock":3000,"price":"29.10","sale_num":0,"recommend_way":0},{"id":33,"site_id":3,"seckill_name":"秒杀","status":1,"remark":"","start_time":1643091335,"end_time":1645715735,"goods_id":826,"seckill_time_id":",2,","seckill_price":"19.90","goods_name":"Striped Lapel Single Breasted Loose Shirt","goods_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122042954164284019481728.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122042954164284019450477.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122042954164284019450141.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122042954164284019482731.jpg","goods_stock":1000,"price":"38.70","sale_num":0,"recommend_way":0},{"id":31,"site_id":3,"seckill_name":"秒杀","status":1,"remark":"","start_time":1643091239,"end_time":1645715639,"goods_id":828,"seckill_time_id":",2,","seckill_price":"9.90","goods_name":"Striped Crew Neck Pocket Decorated Casual Top","goods_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122043700164284062051177.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122043700164284062055788.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122043700164284062046377.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220122\/20220122043700164284062042762.jpg","goods_stock":1600,"price":"25.90","sale_num":0,"recommend_way":0}]},"timestamp":1646878897},
			hdsCodeList: {"code":0,"message":"操作成功","data":{"page_count":1,"count":2,"list":[{"groupbuy_id":1,"groupbuy_price":"35.00","sell_num":0,"site_id":3,"buy_num":2,"sku_id":8112,"price":"40.50","sku_name":"Lace and Tulle Double Back Button Lingerie Set White 75B","sku_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126112946164316778650545.jpg","goods_id":998,"goods_name":"Lace and Tulle Double Back Button Lingerie Set","goods_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126112724164316764442379.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126112724164316764445320.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126112724164316764450324.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126112724164316764449225.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126112724164316764435986.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126112724164316764445573.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126112724164316764435018.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126112724164316764441450.jpg","goods_stock":17997,"recommend_way":0},{"groupbuy_id":2,"groupbuy_price":"30.00","sell_num":0,"site_id":3,"buy_num":2,"sku_id":8070,"price":"36.60","sku_name":"Contrast Lace Mesh Lingerie Set White 70B","sku_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126110346164316622627914.jpg","goods_id":995,"goods_name":"Contrast Lace Mesh Lingerie Set","goods_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126110346164316622619754.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126110346164316622607141.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126110346164316622625724.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126110346164316622609498.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126110346164316622623514.jpg","goods_stock":9900,"recommend_way":0}]},"timestamp":1646894962},
			tdrNowCodelist: {"code":0,"message":"操作成功","data":[{"title":"最近流行","value":{"goodsList":{"type":"goods","value":{"sku_ids":"8325,8241,7798,7762,8070","list":[{"category_name":"WOMEN","goods_id":995,"sku_id":8070,"sku_name":"Contrast Lace Mesh Lingerie Set White 70B","price":"36.60","market_price":"43.00","discount_price":"36.60","stock":300,"sale_num":0,"sku_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126110346164316622627914.jpg","goods_name":"Contrast Lace Mesh Lingerie Set","site_id":3,"website_id":0,"is_own":1,"is_free_shipping":0,"introduction":"","promotion_type":0,"goods_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126110346164316622619754.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126110346164316622607141.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126110346164316622625724.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126110346164316622609498.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220126\/20220126110346164316622623514.jpg","site_name":"soyego","goods_spec_format":"[{\"spec_id\":-391,\"spec_name\":\"Color\",\"value\":[{\"spec_id\":-391,\"spec_name\":\"Color\",\"spec_value_id\":-1284,\"spec_value_name\":\"White\",\"image\":\"\",\"selected\":true,\"sku_id\":8070},{\"spec_id\":-391,\"spec_name\":\"Color\",\"spec_value_id\":-1421,\"spec_value_name\":\"Red\",\"image\":\"\",\"selected\":false,\"sku_id\":8081},{\"spec_id\":-391,\"spec_name\":\"Color\",\"spec_value_id\":-1083,\"spec_value_name\":\"Black\",\"image\":\"\",\"selected\":false,\"sku_id\":8092}]},{\"spec_id\":-722,\"spec_name\":\"Size\",\"value\":[{\"spec_id\":-722,\"spec_name\":\"Size\",\"spec_value_id\":-947,\"spec_value_name\":\"70B\",\"image\":\"\",\"selected\":true,\"sku_id\":8070},{\"spec_id\":-722,\"spec_name\":\"Size\",\"spec_value_id\":-1438,\"spec_value_name\":\"70C\",\"image\":\"\",\"selected\":false,\"sku_id\":8071},{\"spec_id\":-722,\"spec_name\":\"Size\",\"spec_value_id\":-909,\"spec_value_name\":\"75B\",\"image\":\"\",\"selected\":false,\"sku_id\":8072},{\"spec_id\":-722,\"spec_name\":\"Size\",\"spec_value_id\":-1525,\"spec_value_name\":\"75C\",\"image\":\"\",\"selected\":false,\"sku_id\":8073},{\"spec_id\":-722,\"spec_name\":\"Size\",\"spec_value_id\":-994,\"spec_value_name\":\"80B\",\"image\":\"\",\"selected\":false,\"sku_id\":8074},{\"spec_id\":-722,\"spec_name\":\"Size\",\"spec_value_id\":-1465,\"spec_value_name\":\"80C\",\"image\":\"\",\"selected\":false,\"sku_id\":8075},{\"spec_id\":-722,\"spec_name\":\"Size\",\"spec_value_id\":-1016,\"spec_value_name\":\"85C\",\"image\":\"\",\"selected\":false,\"sku_id\":8076},{\"spec_id\":-722,\"spec_name\":\"Size\",\"spec_value_id\":-1329,\"spec_value_name\":\"85B\",\"image\":\"\",\"selected\":false,\"sku_id\":8077},{\"spec_id\":-722,\"spec_name\":\"Size\",\"spec_value_id\":-922,\"spec_value_name\":\"75D\",\"image\":\"\",\"selected\":false,\"sku_id\":8078},{\"spec_id\":-722,\"spec_name\":\"Size\",\"spec_value_id\":-1314,\"spec_value_name\":\"80D\",\"image\":\"\",\"selected\":false,\"sku_id\":8079},{\"spec_id\":-722,\"spec_name\":\"Size\",\"spec_value_id\":-1722,\"spec_value_name\":\"85D\",\"image\":\"\",\"selected\":false,\"sku_id\":8080}]}]","is_virtual":0,"recommend_way":0},{"category_name":"WOMEN","goods_id":975,"sku_id":7798,"sku_name":"Lace Embroidered Adjustable Bra Set Red 70B","price":"37.50","market_price":"0.00","discount_price":"37.50","stock":300,"sale_num":0,"sku_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125060924164310536434530.jpg","goods_name":"Lace Embroidered Adjustable Bra Set","site_id":3,"website_id":0,"is_own":1,"is_free_shipping":0,"introduction":"","promotion_type":0,"goods_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125060924164310536434530.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125060924164310536432164.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125060924164310536421139.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125060924164310536431246.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125060924164310536429141.jpg","site_name":"soyego","goods_spec_format":"[{\"spec_id\":-1004,\"spec_name\":\"Color\",\"value\":[{\"spec_id\":-1004,\"spec_name\":\"Color\",\"spec_value_id\":-1262,\"spec_value_name\":\"Red\",\"image\":\"\",\"selected\":true,\"sku_id\":7798},{\"spec_id\":-1004,\"spec_name\":\"Color\",\"spec_value_id\":-1666,\"spec_value_name\":\"White\",\"image\":\"\",\"selected\":false,\"sku_id\":7808},{\"spec_id\":-1004,\"spec_name\":\"Color\",\"spec_value_id\":-1226,\"spec_value_name\":\"Black\",\"image\":\"\",\"selected\":false,\"sku_id\":7818}]},{\"spec_id\":-677,\"spec_name\":\"Size\",\"value\":[{\"spec_id\":-677,\"spec_name\":\"Size\",\"spec_value_id\":-1244,\"spec_value_name\":\"70B\",\"image\":\"\",\"selected\":true,\"sku_id\":7798},{\"spec_id\":-677,\"spec_name\":\"Size\",\"spec_value_id\":-922,\"spec_value_name\":\"75B\",\"image\":\"\",\"selected\":false,\"sku_id\":7799},{\"spec_id\":-677,\"spec_name\":\"Size\",\"spec_value_id\":-1658,\"spec_value_name\":\"75C\",\"image\":\"\",\"selected\":false,\"sku_id\":7800},{\"spec_id\":-677,\"spec_name\":\"Size\",\"spec_value_id\":-1020,\"spec_value_name\":\"80B\",\"image\":\"\",\"selected\":false,\"sku_id\":7801},{\"spec_id\":-677,\"spec_name\":\"Size\",\"spec_value_id\":-1077,\"spec_value_name\":\"80C\",\"image\":\"\",\"selected\":false,\"sku_id\":7802},{\"spec_id\":-677,\"spec_name\":\"Size\",\"spec_value_id\":-1243,\"spec_value_name\":\"85C\",\"image\":\"\",\"selected\":false,\"sku_id\":7803},{\"spec_id\":-677,\"spec_name\":\"Size\",\"spec_value_id\":-1476,\"spec_value_name\":\"85B\",\"image\":\"\",\"selected\":false,\"sku_id\":7804},{\"spec_id\":-677,\"spec_name\":\"Size\",\"spec_value_id\":-1700,\"spec_value_name\":\"75D\",\"image\":\"\",\"selected\":false,\"sku_id\":7805},{\"spec_id\":-677,\"spec_name\":\"Size\",\"spec_value_id\":-1174,\"spec_value_name\":\"80D\",\"image\":\"\",\"selected\":false,\"sku_id\":7806},{\"spec_id\":-677,\"spec_name\":\"Size\",\"spec_value_id\":-1448,\"spec_value_name\":\"85D\",\"image\":\"\",\"selected\":false,\"sku_id\":7807}]}]","is_virtual":0,"recommend_way":0},{"category_name":"WOMEN","goods_id":974,"sku_id":7762,"sku_name":"Lace rimless Lingerie set White 70A","price":"33.90","market_price":"0.00","discount_price":"33.90","stock":500,"sale_num":0,"sku_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125055751164310467157284.jpg","goods_name":"Lace rimless Lingerie set","site_id":3,"website_id":0,"is_own":1,"is_free_shipping":0,"introduction":"","promotion_type":0,"goods_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125055751164310467162227.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125055751164310467163338.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125055751164310467157284.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125055751164310467158216.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125055751164310467151687.jpg","site_name":"soyego","goods_spec_format":"[{\"spec_id\":-920,\"spec_name\":\"Color\",\"value\":[{\"spec_id\":-920,\"spec_name\":\"Color\",\"spec_value_id\":-1903,\"spec_value_name\":\"White\",\"image\":\"\",\"selected\":true,\"sku_id\":7762},{\"spec_id\":-920,\"spec_name\":\"Color\",\"spec_value_id\":-1386,\"spec_value_name\":\"Red\",\"image\":\"\",\"selected\":false,\"sku_id\":7771},{\"spec_id\":-920,\"spec_name\":\"Color\",\"spec_value_id\":-1770,\"spec_value_name\":\"Grey\",\"image\":\"\",\"selected\":false,\"sku_id\":7780},{\"spec_id\":-920,\"spec_name\":\"Color\",\"spec_value_id\":-1284,\"spec_value_name\":\"Black\",\"image\":\"\",\"selected\":false,\"sku_id\":7789}]},{\"spec_id\":-242,\"spec_name\":\"Size\",\"value\":[{\"spec_id\":-242,\"spec_name\":\"Size\",\"spec_value_id\":-311,\"spec_value_name\":\"70A\",\"image\":\"\",\"selected\":true,\"sku_id\":7762},{\"spec_id\":-242,\"spec_name\":\"Size\",\"spec_value_id\":-641,\"spec_value_name\":\"70B\",\"image\":\"\",\"selected\":false,\"sku_id\":7763},{\"spec_id\":-242,\"spec_name\":\"Size\",\"spec_value_id\":-902,\"spec_value_name\":\"75A\",\"image\":\"\",\"selected\":false,\"sku_id\":7764},{\"spec_id\":-242,\"spec_name\":\"Size\",\"spec_value_id\":-312,\"spec_value_name\":\"75B\",\"image\":\"\",\"selected\":false,\"sku_id\":7765},{\"spec_id\":-242,\"spec_name\":\"Size\",\"spec_value_id\":-874,\"spec_value_name\":\"75C\",\"image\":\"\",\"selected\":false,\"sku_id\":7766},{\"spec_id\":-242,\"spec_name\":\"Size\",\"spec_value_id\":-1106,\"spec_value_name\":\"80B\",\"image\":\"\",\"selected\":false,\"sku_id\":7767},{\"spec_id\":-242,\"spec_name\":\"Size\",\"spec_value_id\":-245,\"spec_value_name\":\"80C\",\"image\":\"\",\"selected\":false,\"sku_id\":7768},{\"spec_id\":-242,\"spec_name\":\"Size\",\"spec_value_id\":-627,\"spec_value_name\":\"85C\",\"image\":\"\",\"selected\":false,\"sku_id\":7769},{\"spec_id\":-242,\"spec_name\":\"Size\",\"spec_value_id\":-1228,\"spec_value_name\":\"85B\",\"image\":\"\",\"selected\":false,\"sku_id\":7770}]}]","is_virtual":0,"recommend_way":0},{"category_name":"WOMEN","goods_id":977,"sku_id":8241,"sku_name":"Floral Embroidery Lace Trim Bra Set White 70A","price":"36.21","market_price":"40.00","discount_price":"36.21","stock":200,"sale_num":0,"sku_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125062203164310612352464.jpg","goods_name":"Floral Embroidery Lace Trim Bra Set","site_id":3,"website_id":0,"is_own":1,"is_free_shipping":0,"introduction":"","promotion_type":0,"goods_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125062203164310612348913.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125062203164310612351176.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125062203164310612352464.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125062203164310612346286.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/3\/common\/images\/20220125\/20220125062203164310612337529.jpg","site_name":"soyego","goods_spec_format":"[{\"spec_id\":-582,\"spec_name\":\"Color\",\"value\":[{\"spec_id\":-582,\"spec_name\":\"Color\",\"spec_value_id\":-1582,\"spec_value_name\":\"White\",\"image\":\"\",\"selected\":true,\"sku_id\":8241},{\"spec_id\":-582,\"spec_name\":\"Color\",\"spec_value_id\":-1551,\"spec_value_name\":\"Gray-blue\",\"image\":\"\",\"selected\":false,\"sku_id\":8262}]},{\"spec_id\":-123,\"spec_name\":\"Size\",\"value\":[{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-940,\"spec_value_name\":\"70A\",\"image\":\"\",\"selected\":true,\"sku_id\":8241},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-885,\"spec_value_name\":\"75A\",\"image\":\"\",\"selected\":false,\"sku_id\":8242},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-1037,\"spec_value_name\":\"80A\",\"image\":\"\",\"selected\":false,\"sku_id\":8243},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-872,\"spec_value_name\":\"70B\",\"image\":\"\",\"selected\":false,\"sku_id\":8244},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-392,\"spec_value_name\":\"75B\",\"image\":\"\",\"selected\":false,\"sku_id\":8245},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-1049,\"spec_value_name\":\"80B\",\"image\":\"\",\"selected\":false,\"sku_id\":8246},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-715,\"spec_value_name\":\"85B\",\"image\":\"\",\"selected\":false,\"sku_id\":8247},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-887,\"spec_value_name\":\"70C\",\"image\":\"\",\"selected\":false,\"sku_id\":8248},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-361,\"spec_value_name\":\"75C\",\"image\":\"\",\"selected\":false,\"sku_id\":8249},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-965,\"spec_value_name\":\"80C\",\"image\":\"\",\"selected\":false,\"sku_id\":8250},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-1048,\"spec_value_name\":\"85C\",\"image\":\"\",\"selected\":false,\"sku_id\":8251},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-243,\"spec_value_name\":\"90C\",\"image\":\"\",\"selected\":false,\"sku_id\":8252},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-175,\"spec_value_name\":\"70D\",\"image\":\"\",\"selected\":false,\"sku_id\":8253},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-891,\"spec_value_name\":\"75D\",\"image\":\"\",\"selected\":false,\"sku_id\":8254},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-1029,\"spec_value_name\":\"80D\",\"image\":\"\",\"selected\":false,\"sku_id\":8255},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-200,\"spec_value_name\":\"85D\",\"image\":\"\",\"selected\":false,\"sku_id\":8256},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-394,\"spec_value_name\":\"90D\",\"image\":\"\",\"selected\":false,\"sku_id\":8257},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-548,\"spec_value_name\":\"70E\",\"image\":\"\",\"selected\":false,\"sku_id\":8258},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-799,\"spec_value_name\":\"75E\",\"image\":\"\",\"selected\":false,\"sku_id\":8259},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-714,\"spec_value_name\":\"80E\",\"image\":\"\",\"selected\":false,\"sku_id\":8260},{\"spec_id\":-123,\"spec_name\":\"Size\",\"spec_value_id\":-291,\"spec_value_name\":\"85E\",\"image\":\"\",\"selected\":false,\"sku_id\":8261}]}]","is_virtual":0,"recommend_way":0},{"category_name":"WOMEN","goods_id":981,"sku_id":8325,"sku_name":"Lace Floral Vest Lingerie Black","price":"29.00","market_price":"34.00","discount_price":"29.00","stock":200,"sale_num":0,"sku_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/2\/common\/images\/20220127\/20220127050813164327449399487.jpg","goods_name":"Lace Floral Vest Lingerie","site_id":2,"website_id":0,"is_own":1,"is_free_shipping":0,"introduction":"","promotion_type":0,"goods_image":"http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/2\/common\/images\/20220127\/20220127050814164327449402550.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/2\/common\/images\/20220127\/20220127050813164327449385872.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/2\/common\/images\/20220127\/20220127050814164327449400363.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/2\/common\/images\/20220127\/20220127050813164327449399487.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/2\/common\/images\/20220127\/20220127050814164327449406633.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/2\/common\/images\/20220127\/20220127050813164327449396691.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/2\/common\/images\/20220127\/20220127050814164327449404478.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/2\/common\/images\/20220127\/20220127050813164327449395880.jpg,http:\/\/beeyo-com.oss-accelerate.aliyuncs.com\/upload\/2\/common\/images\/20220127\/20220127050814164327449403326.jpg","site_name":"beeyo_shop","goods_spec_format":"[{\"spec_id\":-499,\"spec_name\":\"Color\",\"value\":[{\"spec_id\":-499,\"spec_name\":\"Color\",\"spec_value_id\":-1482,\"spec_value_name\":\"Black\",\"image\":\"\",\"selected\":true,\"sku_id\":8325},{\"spec_id\":-499,\"spec_name\":\"Color\",\"spec_value_id\":-548,\"spec_value_name\":\"Pink\",\"image\":\"\",\"selected\":false,\"sku_id\":8326},{\"spec_id\":-499,\"spec_name\":\"Color\",\"spec_value_id\":-1169,\"spec_value_name\":\"Red\",\"image\":\"\",\"selected\":false,\"sku_id\":8327}]}]","is_virtual":0,"recommend_way":0}]}},"bottomImg":{"type":"img","value":{"url":"","link":""}},"title":{"type":"text","value":{"text":"楼层标题","link":"","color":"#330000"}},"subTitle":{"type":"text","value":{"text":"楼层副标题","link":"","color":"#b0b0b0"}}},"block_name":"floor-style-2","block_title":"样式2"}],"timestamp":1646899744},

			strCurXSoyego: localStorage.getItem("strCurXSoyego"), //货币单位
			countrySoyego: localStorage.getItem("countrySoyego"), //货币
			discountCode: "",
			loadLikeing: true,
			id: sessionStorage.getItem("treeOneIdSoyego"),
			likeList: [],
			rubikCubeList: [],
			rubikCubeLoading: true,
			imageOne: [],
			imageOneLoading: true,
			imageOne1: [],
			imageOne1Loading: true,
			newInList: [],		// 新品上市商品数据
			newInLoading: true,
			imgTo: "",
			loginShow: false,
			buyNow: false,
			bagShop: false,
            ids: -1,
			indexTemplate: "DIY_VIEW_INDEX",
			diyviewInfoList: [],

			// 首页模板类型
			indexTemplate: localStorage.getItem('indexTemplateSoyego') || 'DIY_VIEW_INDEX',
			// 首页模板类型id
			category_id: localStorage.getItem('treeOneId') || 4,	
			


			carouselData: [], 		// 轮播图数据
			bannerHeight: 0,		// 轮播图的高度
			carouselLoading: true,	// 轮播图loading
			rubikCube: [], 			// 魔方数据
			categoryData: [],		// 分类数据
			blowoutSaleBanner: '',  // 爆款广告banner图
			blowoutSaleLink: '',	// 爆款链接
			blowoutSaleData: [], 	// 爆款广告商品数据
			newInBanner: '',		// 每日上新banner图
			newInLink: '',			// 每日上新链接
			newInGoodsData: [],		// 每日上新商品数据
		}
	},
	watch: {
		searchType() {
			this.searchTypeText = this.searchType == "goods" ? "商品" : "店铺"
		},
		
		$route: "fetchData",
		// 监听屏幕宽度变化，变更顶部轮播图的高度
		// showWidth: function (n, o) {
		// 	// console.log(n * 803 / 1920);
		// 	// width = n * 803 / 1920;
		// 	// this.showWidth = width;
        // },
	},
	created() {
		this.tokenIf()
		switch(this.id) {
			case "4" : this.indexTemplate = "DIY_VIEW_INDEX";break;
			case "171" : this.indexTemplate = "DIY_VIEW_INDEX_2";break;
			case "7" : this.indexTemplate = "DIY_VIEW_INDEX_3";break;
			case "193" : this.indexTemplate = "DIY_VIEW_INDEX_4";break;
			case "194" : this.indexTemplate = "DIY_VIEW_INDEX_5";break;
			case "9" : this.indexTemplate = "DIY_VIEW_INDEX_6";break;
			case "15" : this.indexTemplate = "DIY_VIEW_INDEX_7";break;
			default : break;
		}
		this.getNotice()
		this.getBigAdList()
		this.getSmallAdList()
		// if(this.city.id > 0){
		// 	this.getIndexGoodsList();
		// }else{
		// 	this.getFloors();
		// 	this.getFloatLayer();
		// 	if(this.addonIsExit && this.addonIsExit.seckill == 1){
		// 		this.getTimeList();
		// 	}
		// 	this.getCanReceiveCouponQuery();
		// }
	
		// this.getFloatLayer()
		this.$store.dispatch("site/siteInfo") // 站点信息
		this.getDefaultSearchWords() // 默认搜索类型
		// if(this.addonIsExit && this.addonIsExit.seckill == 1){
			this.getTimeList()
		// }
		// this.getCanReceiveCouponQuery()

		this.getDiyviewInfo();
		this.getGroupbuyPpage();
		// this.getPcFloors();
		this.getNewIN();
		this.getGoodsLike();

		this.getIndexData();
	},
	mounted() {
		window.addEventListener("scroll", this.handleScroll)
      	// this.mySwiper.slideTo(3, 1000, false)

		// 轮播图自适应高度
		this.screenWidth = window.innerWidth;
		this.bannerHeight = 800 / 1920 * this.screenWidth; // 首次加载时,初始化高度
		// 监听屏幕宽度变化
		window.onresize = () => {
			this.screenWidth = window.innerWidth
			this.bannerHeight = 800 / 1920 * this.screenWidth;
		}
	},
	computed: {
		...mapGetters(["defaultHeadImage", "addonIsExit", "defaultGoodsImage", "member", "siteInfo", "cartCount","city"]),
		optionLeft() {
			return {
				direction: 2,
				limitMoveNum: 1
			}
		}
	},
	methods: {
		tokenIf() {
            let token = getToken();
            if(token == undefined){
                this.is_overlay = false;
            }else{
                this.is_overlay = true;
            }
        },
		collectClick(item) {
			console.log(item)
            var that = this;
            var token = getToken();
            if(token == undefined){
                this.$router.push({ path: '/login' })
            }else{
                if(item.is_collect == 0) {
                    addCollect({
                        sku_id: item.sku_id,
                        goods_id: item.goods_id
                    }).then( res => {
                        if(res.code == 0 && res.data){
                            that.likeList.forEach(items => {
                                if(items.goods_id == item.goods_id) {
                                    items.is_collect = 1;
                                }
                            });
                            this.$message.success('Collection success');
                        }
                    }).catch( err => {
                        this.$message.error('Collection failed');
                        // console.log(err)
                    })
                }else if(item.is_collect == 1){
                    deleteGoods({
                        goods_id: item.goods_id
                    }).then( res => {
                        if(res.code == 0){
                            that.likeList.forEach(items => {
                                if(items.goods_id == item.goods_id) {
                                    items.is_collect = 0;
                                }
                            });
                            this.$message.success('Cancel collection');
                        }
                    }).catch( err => {
                        this.$message.error('Failed to cancel collection');
                        // console.log(err)
                    })
                }
            }
        },
		bagShopClick(stuId) {
			this.ids = stuId;
			this.bagShop = true;
		},
		handleClose() {
            this.bagShop = false;
        },
		prevClick(){
			this.$refs.trending.prev();
		},
		nextClick() {
			this.$refs.trending.next();
		},
		detailsClick(id) {
            localStorage.setItem('productDetailsDropSoyego', false);
            const blank = this.$router.resolve({path: '/productDetails', query: {sku_id: id}})
            window.open(blank.href,'_blank')
        },
		mouseRight(id) {
            // localStorage.removeItem("productDetailsSoyego");
            localStorage.setItem('productDetailsDropSoyego', false);
            // localStorage.setItem('productDetailsSoyego', id);
            this.imgTo = "/productDetails?sku_id=" + id;
        },
		getGoodsLike(like) {
            this.loadLikeing = true;
            const params = {
                page: 1,
                page_size: 15,
                attr_rand: true,
                category_id: this.category_id,
				is_overlay: this.is_overlay,
				barterRate: localStorage.getItem("countrySoyego")
            };
            goodsSkuPage(params || {}).then(res => {
                if (res.code == 0 && res.data) {
                    let data = res.data;
                    data.list.forEach(item => {
                        item.goods_image = item.goods_image.split(',');
						item.discount_price = Number(item.discount_price).toFixed(2);
						item.market_price = Number(item.market_price).toFixed(2);
                    });
                    if(like){
                        this.likeList = this.likeList.concat(data.list);
                    }else{
                        this.likeList = data.list;
                    }
                    this.loadLikeing = false;
                }
            }).catch(err => {
                this.$message.error(err.message);
                this.loadLikeing = false;
            });
        },
		fetchData() {
			if(this.$route.query){
                if(this.$route.query.Stab != undefined){
                    this.id = this.$route.query.Stab;
					switch(this.id) {
						case "4" : this.indexTemplate = "DIY_VIEW_INDEX";break;
						case "171" : this.indexTemplate = "DIY_VIEW_INDEX_2";break;
						case "7" : this.indexTemplate = "DIY_VIEW_INDEX_3";break;
						case "193" : this.indexTemplate = "DIY_VIEW_INDEX_4";break;
						case "194" : this.indexTemplate = "DIY_VIEW_INDEX_5";break;
						case "9" : this.indexTemplate = "DIY_VIEW_INDEX_6";break;
						case "15" : this.indexTemplate = "DIY_VIEW_INDEX_7";break;
						default : break;
					}
					this.getDiyviewInfo();
					this.getNewIN();
					this.getGoodsLike();
					this.getIndexData();
                }
            }
			this.reload();
		},
		// 获取首页数据
		getDiyviewInfo() {
			const params = {
				name: this.indexTemplate,
				website_id: 0
			}
			var that = this;
			diyviewInfo(params || {})
				.then(res => {
					let data = JSON.parse(res.data.value);
					let value = data.value;
					this.diyviewInfoList = value;
					// console.log(this.diyviewInfoList)
				})
				.catch(err => {
					// console.log(err)
				})
		},
		getNewIN() {
			let time = this.getTimetamp();
			const params = {
                page: 1,
                page_size: 20,
                category_id: this.category_id,
                start_time: time.start_time,
                end_time: time.end_time,
                barterRate: localStorage.getItem("countrySoyego")
            };
            goodsReco(params || {}).then(res => {
                if (res.code == 0 && res.data) {
                    let data = res.data;
                    data.list.forEach(item => {
                        item.category_id = item.category_id.split(',');
                        item.goods_image = item.goods_image.split(',');
						item.price = Number(item.price).toFixed(2);
                    });
                    this.newInList = data.list;
					// console.log('每日上新',this.newInList)
					// 翻译
					// let strText = '';
					// data.list.forEach((item,index) => {
					// 	strText += item.goods_name + '\n'
					// })
					// this.$fanyi.translateData({
					// 	query: strText,
					// 	success: resData => {
					// 		this.newInList.forEach((item,index) => {
					// 			this.newInList[index].goods_name = resData[index];
					// 		})
					// 	}
					// });
					// 停止loading
                    this.newInLoading = false;
                }
            }).catch(err => {
                this.newInLoading = false;
                this.$message.error(err.message);
            });
		},
		getTimetamp(){
            var data = new Date();
            data.setHours(0);
            data.setSeconds(0);
            data.setMinutes(0);
            // // dateObject 的月份字段，使用本地时间。返回值是 0（一月） 到 11（十二月） 之间的一个整数。
            var data1 = new Date(); // 下一年
            data1.setHours(23);
            data1.setSeconds(59);
            data1.setMinutes(59);
            // console.log('当天0点' + data.getTime())
            // console.log('当天23点' + data1.getTime())
            var timeStart = parseInt(data.getTime() / 1000);
            var timeEnd = parseInt(data1.getTime() / 1000); //(计算当前23点的时间戳-1即可)
            var time = {
                start_time: timeStart,
                end_time: timeEnd
            }
            return time;
        },
		toDetailClick(id) {
			localStorage.setItem('productDetailsDropSoyego', false);
            const blank = this.$router.resolve({path: '/productDetails', query: {sku_id: id}})
            window.open(blank.href,'_blank')
		},
		getGroupbuyPpage(){
			goodsPage().then(res => {
					if(res.code == 0 && res.data){
						// console.log(this.hdsCodeList.data.list)
						// for(let i = 0; i < this.hdsCodeList.data.list.length; i++){
						// 	this.hdsList[i] = this.hdsCodeList.data.list[i];
						// 	let images = this.hdsCodeList.data.list[i].goods_image.split(',');
						// 	this.hdsList[i].goods_image = images;
						// }
						for(let i = 0; i < res.data.list.length; i++){
							this.hdsList[i] = res.data.list[i];
							let images = res.data.list[i].goods_image;
							if(res.data.list[i].goods_image){
								images = res.data.list[i].goods_image.split(',');
							}
							this.hdsList[i].goods_image = images;
						}
						this.hdsListLoading = false;
					}
				})
				.catch(err => {
					this.hdsListLoading = false;
					this.$message.error(err.message);
				});
		},
		getPcFloors() {
			floors()
				.then(res => {
					if(res.code == 0 && res.data){
						// this.tdrNowList = this.tdrNowCodelist.data[0].value.goodsList.value.list;
						// for(let i = 0; this.tdrNowCodelist.data[0].value.goodsList.value.list.length; i++){
						// 	this.tdrNowList[i].goods_image = this.tdrNowCodelist.data[0].value.goodsList.value.list[i].goods_image.split(',');
						// }

						this.tdrNowList = res.data[0].value.goodsList.value.list;
						for(let i = 0; res.data[0].value.goodsList.value.list.length; i++){
							this.tdrNowList[i].goods_image = res.data[0].value.goodsList.value.list[i].goods_image;
							if(res.data[0].value.goodsList.value.list[i].goods_image){
								this.tdrNowList[i].goods_image = res.data[0].value.goodsList.value.list[i].goods_image.split(',');
							}
							
						}
						this.tdrNowListLoading = false;
					}
				})
				.catch(err => {
					this.tdrNowListLoading = false;
					// console.log(err)
				})
		},
		arrowPrev() {
			this.$refs.mySwiper.$swiper.slidePrev()
			// this.swiper.slidePrev()
		},
		arrowNext() {
			this.$refs.mySwiper.$swiper.slideNext()
			// this.swiper.slideNext()
		},
		arrowPrev2() {
			this.$refs.mySwiper2.$swiper.slidePrev()
			// this.swiper.slidePrev()
		},
		arrowNext2() {
			this.$refs.mySwiper2.$swiper.slideNext()
			// this.swiper.slideNext()
		},
		/*
		 * 解决秒杀组件复制出来的没有点击事件
		 */
		clickProps(e){
			if(!e.target.dataset.obj){ return }
			let item = JSON.parse(e.target.dataset.obj);
			this.$router.pushToTab('/promotion/seckill-' + item.id)
		},
		countDownS_cb() {},
		countDownE_cb() {
			this.seckillText = "活动已结束"
		},
		getIndexGoodsList() {
			goodsSkuPage({
				})
				.then(res => {
					this.goodsList = res.data.list;
				})
				.catch(err => {
				})
		},
		getAdList() {
			adList({
					keyword: "NS_PC_INDEX"
				})
				.then(res => {
					this.adList = res.data.adv_list
					for (let i = 0; i < this.adList.length; i++) {
						if (this.adList[i].adv_url) this.adList[i].adv_url = JSON.parse(this.adList[i].adv_url)
					}
					this.backgroundColor = this.adList[0].background
					this.loadingAd = false
				})
				.catch(err => {
					this.loadingAd = false
				})
		},
		handleChange(curr, pre) {
			this.backgroundColor = this.adList[curr].background
		},
		/* 秒杀图片处理 */
		goodsImg(imgStr) {
			// let imgs = imgStr.split(',');
			// return imgs[0] ? this.$util.img(imgs[0], { size: 'mid' }) : this.defaultGoodsImage;
		},
		/**
		 * 广告位大图
		 */
		getBigAdList() {
			adList({
					keyword: "NS_PC_INDEX_MID_LEFT"
				})
				.then(res => {
					this.adLeftList = res.data.adv_list
					for (let i = 0; i < this.adLeftList.length; i++) {
						if (this.adLeftList[i].adv_url) this.adLeftList[i].adv_url = JSON.parse(this.adLeftList[i].adv_url)
					}
					this.loadingAd = false
				})
				.catch(err => {
					this.loadingAd = false
				})
		},
		/**
		 * 广告位小图
		 */
		getSmallAdList() {
			adList({
					keyword: "NS_PC_INDEX_MID_RIGHT"
				})
				.then(res => {
					this.adRightList = res.data.adv_list
					for (let i = 0; i < this.adRightList.length; i++) {
						if (this.adRightList[i].adv_url) this.adRightList[i].adv_url = JSON.parse(this.adRightList[i].adv_url)
					}
					this.loadingAd = false
				})
				.catch(err => {
					this.loadingAd = false
				})
		},
		getNotice() {
			noticesList({
					page: 1,
					page_size: 5,
					receiving_type: "web"
				})
				.then(res => {
					this.noticeList = res.data.list
				})
				.catch(err => err)
		},
		//获取优惠券列表
		getCanReceiveCouponQuery() {
			couponList({
					activeName: "second",
					site_id: this.siteId
				})
				.then(res => {
					let data = res.data
					this.couponList = []
					if (data != null) {
						for (let i = 0; i < data.list.length; i++) {
							if (i < 5) {
								this.couponList.push(data.list[i])
							}
						}
						this.couponList.forEach(v => {
							v.useState = 0
						})
					}
				})
				.catch(err => {})
		},
		/**
		 * 领取优惠券
		 */
		receiveCoupon(item, index) {
			if (this.isSub) return
			this.isSub = true

			var data = {
				site_id: item.site_id,
				activeName: "second",
				platformcoupon_type_id: item.platformcoupon_type_id
			}

			receiveCoupon(data)
				.then(res => {
					var data = res.data
					let msg = res.message
					if (res.code == 0) {
						msg = "领取成功"
						this.$message({
							message: msg,
							type: "success"
						})
					} else {
						this.$message({
							message: msg,
							type: "warning"
						})
					}
					let list = this.couponList
					if (res.data.is_exist == 1) {
						for (let i = 0; i < list.length; i++) {
							if (list[i].platformcoupon_type_id == item.platformcoupon_type_id) {
								list[i].useState = 1
							}
						}
					} else {
						for (let i = 0; i < list.length; i++) {
							if (list[i].platformcoupon_type_id == item.platformcoupon_type_id) {
								list[i].useState = 2
							}
						}
					}

					this.isSub = false
					this.$forceUpdate()
				})
				.catch(err => {
					if (err.message == 'token不存在') {
						this.$router.pushToTab('/login')
					} else {
						this.$message.error(err.message);
					}
					this.isSub = false
				})
		},
		/**
		 * 点击优惠券
		 */
		couponTap(item, index) {
			if (item.useState == 0) this.receiveCoupon(item, index)
			else this.toGoodsList(item)
		},
		/**
		 * 去购买
		 */
		toGoodsList(item) {
			if (item.use_scenario != 1) {
				this.$router.push({
					path: "/list",
					query: {
						platformcouponTypeId: item.platformcoupon_type_id
					}
				})
			} else {
				this.$router.push("/list")
			}
		},
		/**
		 * 限时秒杀
		 */
		getTimeList() {
			var that = this;
			timeList()
				.then(res => {
					// res = that.ddpsTimeList;
					if (res.code == 0 && res.data.list) {
						let time = new Date(res.timestamp * 1000)
						let currentTimes = time.getHours() * 60 * 60 + time.getMinutes() * 60 + time.getSeconds()
						res.data.list.forEach((v, k) => {
							let images = v.goods_image;
							if(v.goods_image != undefined){
								images = v.goods_image.split(',');
							}else{
								images = '';
							}
							v.goods_image = images;
							// console.log(res.data.list)
							// currentTimes = currentTimes + 10000;
							if (v.seckill_start_time <= currentTimes && currentTimes < v.seckill_end_time) {
								let seckillId = v.id
								// console.log(seckillId)
								this.getGoodsList(seckillId)

								let endTime = parseInt(time.getTime() / 1000) + (v.seckill_start_time - currentTimes)
								this.seckillTimeMachine = {
									currentTime: res.timestamp,
									startTime: res.timestamp,
									endTime: endTime
								}
							}
						})
						
						// console.log(that.ddpsList)
					}
				})
				.catch(err => {
					that.ddpsListLoading = false;
					this.$message.error(err.message)
				})
		},
		/**
		 * 秒杀商品
		 */
		getGoodsList(id) {
			// console.log(id)
			goodsPageSeckill({
					page_size: 0,
					seckill_id: id,
					site_id: this.siteId
				})
				.then(res => {
					if (res.code == 0 && res.data.list) {
						res.data.list.forEach((item) => {
							item.goods_image = item.goods_image.split(',');
						})
						this.ddpsList = res.data.list;
						this.ddpsListLoading = false;
						// this.listData = res.data.list
						// console.log(this.listData)
					}
				})
				.catch(err => {})
		},
		/**
		 * 图片加载失败
		 */
		imageError(index) {
			this.listData[index].sku_image = this.defaultGoodsImage
		},
		/**
		 * 图片加载失败
		 */
		adLeftImageError(index) {
			this.adLeftList[index].adv_image = this.defaultGoodsImage
		},
		/**
		 * 图片加载失败
		 */
		adRightImageError(index) {
			this.adRightList[index].adv_image = this.defaultGoodsImage
		},
		getFloors() {
			floors()
				.then(res => {
					this.floorList = res.data;
					// console.log(res,'res')
				})
				.catch(err => {
					// console.log(err)
				})
		},
		getFloatLayer() {
			floatLayer()
				.then(res => {
					if (res.code == 0 && res.data) {
						this.floatLayer = res.data
						this.floatLayer.link = JSON.parse(this.floatLayer.url)
						// 弹框形式，首次弹出 1，每次弹出 0

						if (!this.floatLayer.img_url) return

						if (parseInt(this.floatLayer.number) == 1) {
							var index_popwindow_count = this.$store.state.app.indexFloatLayerNum;
							if (index_popwindow_count == '' || index_popwindow_count == 1) {
								this.floatLayer.is_show = true
								this.$store.commit("app/SET_FLOAT_LAYER", 1)
							}
						} else if (parseInt(this.floatLayer.number) == 0) {
							this.floatLayer.is_show = true
							this.$store.commit("app/SET_FLOAT_LAYER", 0)
						}
					}
				})
				.catch(err => err)
		},
		closeFloat() {
			this.floatLayer.is_show = false
			this.$forceUpdate()
			this.$store.commit("app/SET_FLOAT_LAYER", -1)
		},
		// 监听滚动条
		handleScroll() {
			var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

			if (scrollTop >= 680) {
				this.isShow = true
			} else {
				this.isShow = false
			}
		},
		destroyed() {
			// 离开该页面需要移除这个监听的事件，不然会报错
			window.removeEventListener("scroll", this.handleScroll)
		},
		/**
		 * 默认搜索类型（goods/shop）
		 */
		getDefaultSearchWords() {
			apiDefaultSearchWords({}).then(res => {
				if (res.code == 0 && res.data.words) {
					this.defaultSearchWords = res.data.words
				}
			})
		},
		handleCommand(command) {
			this.searchType = command
		},
		search() {
			if (this.searchType == "goods") this.$router.push({
				path: "/list",
				query: {
					keyword: this.keyword
				}
			})
			else this.$router.push({
				path: "/street",
				query: {
					keyword: this.keyword
				}
			})
		},
		
		// 获取首页数据
		getIndexData() {
			var that = this;
			const params = {
				name: this.indexTemplate,
				website_id: 0
			}
			diyviewInfo(params || {})
				.then(res => {
					let data = JSON.parse(res.data.value);
					let value = data.value;
					this.diyviewInfoList = value;
					console.log('首页数据',this.diyviewInfoList)
					this.diyviewInfoList.forEach((item,index) => {
						// 首页轮播图
						if(item.name == '图片广告' && item.selectedTemplate == 'carousel-posters') {
							that.getCarouselData(item);
						}
						// 魔方数据
						if(item.name == '魔方' && item.controller == 'RubikCube') {
							that.getRubikCubeData(item);
						}
						// 分类数据
						if(item.name == '图文导航' && item.selectedTemplate == 'imageNavigation' && item.controller == 'GraphicNav') {
							that.getCategoryData(item);
						}
						// 爆款广告banner
						if(item.name == '图片广告' && item.list[0].title == 'blowoutSale') {
							let imageUrl = item.list[0].imageUrl;
							let link = item.list[0].link.name;
							that.blowoutSaleBanner = imageUrl;
							that.blowoutSaleLink = link;
							let id = this.diyviewInfoList[index+1].categoryId;
							console.log(item,index)
							// 爆款商品数据
							that.getBlowoutSaleData(id);
						}
						
						// 每日上新banner
						if(item.name == '图片广告' && item.list[0].title == 'newInBanner') {
							that.newInBanner = item.list[0].imageUrl;
							that.newInLink = item.list[0].link.name;
							console.log('每日上新',item)
							// 获取每日上新数据
							that.getNewInData();
						}
					})
					
				})
				.catch(err => {
					// console.log(err)
				})
		},
		// 获取首页顶部轮播图数据
		getCarouselData(data) {
			var that = this;
			data.list.forEach(item => {
				if(item.link.wap_url != "" && item.link.wap_url != undefined){
					var i = item.link.wap_url.lastIndexOf("=");
					item.link.wap_url = item.link.wap_url.substring(i + 1, item.link.wap_url.length);
				}
			});
			that.carouselData = data.list;
			this.carouselLoading = false;
		},
		// 获取首页魔方数据
		getRubikCubeData(data) {
			var that = this;
			that.rubikCube = data.list;
			this.loadLikeing = false;
		},
		// 获取分类数据
		getCategoryData(data) {
			var that = this;
			that.categoryData = data.list;
			console.log(data)
			this.loadLikeing = false;
		},
		// 获取爆款商品数据
		getBlowoutSaleData(id) {
			var that = this;
			const params = {
				page: 1,
				page_size: 5,
				is_overlay: false,
				site_id: 0,
				category_id: id,
				category_level: 1,
				barterRate: 'USD',
			}
			goodsSkuPage(params || {}).then(res => {
                if (res.code == 0 && res.data) {
                    let data = res.data;
					console.log('爆款',data);
					that.blowoutSaleData = data.list;
                }
            }).catch(err => {
                
            })
		},
		// 获取每日上新商品数据
		getNewInData() {
			let time = this.getTimetamp();
			const params = {
                page: 1,
                page_size: 4,
                category_id: this.category_id,
                start_time: time.start_time,
                end_time: time.end_time,
                barterRate: localStorage.getItem("countrySoyego")
            };
            goodsReco(params || {}).then(res => {
                if (res.code == 0 && res.data) {
                    let data = res.data;
                    data.list.forEach(item => {
                        item.category_id = item.category_id.split(',');
                        item.goods_image = item.goods_image.split(',');
						item.price = Number(item.price).toFixed(2);
                    });
                    this.newInGoodsData = data.list;
					console.log('每日上新',this.newInGoodsData)
                }
            }).catch(err => {
                this.newInLoading = false;
                this.$message.error(err.message);
            });
		},
	}
}
